"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class TwingExtension {
    constructor() {
        this.TwingExtensionInterfaceImpl = this;
    }
    getTokenParsers() {
        return [];
    }
    getNodeVisitors() {
        return [];
    }
    getFilters() {
        return new Map();
    }
    getTests() {
        return [];
    }
    getFunctions() {
        return new Map();
    }
    getOperators() {
        return [new Map(), new Map()];
    }
}
exports.TwingExtension = TwingExtension;
